import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Fraccion1Service } from 'src/services/Articulo8/Fraccion1.service';
import { GeneralService } from 'src/services/general.service';

@Component({
  selector: 'app-jefes',
  templateUrl: './jefes.component.html',
  styleUrls: ['./jefes.component.scss']
})
export class JefesComponent {
  idNoticia: any;
  boton: any;
  noticias: any;
  noticia: any;

  constructor(private activerouter: ActivatedRoute, private router: Router, private api: Fraccion1Service, private general: GeneralService) { }

  ngOnInit(): void {

    if (localStorage.getItem('token')) {
      this.boton = 1;
    }

    this.idNoticia = this.activerouter.snapshot.paramMap.get('id');
    console.log(this.idNoticia);

    this.general.verPersonal2().subscribe(res => {
      this.noticias = res.body;
      console.log(this.noticias);

    })



  }

  subirNoticia() {
    localStorage.setItem('idNoticia', this.idNoticia);
    this.router.navigate(['admin/subir-noticia']);
  }
}
